import React from 'react';
import './style.scss';
import { NFTRank } from 'shared';

interface Props {
  rank: NFTRank;
  className?: string;
}

const NftRankLine = ({ rank, className = 'body-2' }: Props) => {
  return (
    <div className='nft-rank-line'>
      <span className={className}>{rank.name}</span>
      <span className={className}>
        {[...Array(rank.stars)].map(() => '⭐').join('')}
      </span>
    </div>
  );
};

export default NftRankLine;
